module.exports = __webpack_public_path__ + "img/ic_account.41ce4459.svg";